import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';

interface HelperTablesProps {
  onClose: () => void;
}

const HelperTables: React.FC<HelperTablesProps> = ({ onClose }) => {
  return (
    <div className="container content-tables">       
      <h4 className="table-header">טבלת שוק לטריאז'</h4>
      <table className="table table-striped" style={{ marginTop: 20 }}>
        <thead>
          <tr>
            <th scope="col" className="helper-table-first-col"></th>
            <th scope="col">שוק</th>
            <th scope="col" className="helper-table-last-col">לא שוק</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" className="helper-table-first-col">דופק</th>
            <td>מהיר לגיל (לא עקב חום \ בכי \ כאב)</td>
            <td className="helper-table-last-col">תקין לגיל</td>
          </tr>
          <tr>
            <th scope="row" className="helper-table-first-col">מילוי קפילרי \ צבע עור</th>
            <td>לא תקין</td>
            <td className="helper-table-last-col">תקין</td>
          </tr>
          <tr>
            <th scope="row" className="helper-table-first-col">ל"ד</th>
            <td>נמוך לגיל</td>
            <td className="helper-table-last-col">תקין</td>
          </tr>
          <tr>
            <th scope="row" className="helper-table-first-col">הכרה</th>
            <td>לא תקינה (עייף \ ישנוני)</td>
            <td className="helper-table-last-col">תקין</td>
          </tr>
        </tbody>
      </table>
      
      <h4>חומרת אסטמה לטריאז'</h4>
      <table className="table table-striped" style={{ marginTop: 20 }}>
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">קלה</th>
            <th scope="col">בינונית</th>
            <th scope="col">קשה</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">סטורציה</th>
            <td>מעל 95% RA</td>
            <td>מתחת 95% RA</td>
            <td>מתחת 90% RA</td>
          </tr>
          <tr>
            <th scope="row">קצב נשימות</th>
            <td>תקין לגיל</td>
            <td>מהיר לגיל</td>
            <td>מהיר מאוד</td>
          </tr>
          <tr>
            <th scope="row">שימוש בשרירי עזר</th>
            <td>ללא או מינימלי</td>
            <td>קיים</td>
            <td>משמעותי</td>
          </tr>
          <tr>
            <th scope="row">הכרה \ צבע</th>
            <td>תקין</td>
            <td>תקין</td>
            <td>לא תקין</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default HelperTables;